import { ProjectConfigurationDc } from "@evergis/api";
import { Coordinates } from "@evergis/sgis/es/baseTypes";

import { DEFAULT_BASE_MAP, DEFAULT_PROJECT_CONTENT } from "../../evergis/core/project/createProjectContent";
import { BaseMapItem } from "../../modules/MapControls/components/BasemapSelect/BasemapBlock";
import { useBasemapSelectModule, useMapModule } from "../appConfig/useAppModule";

const { position, resolution } = DEFAULT_PROJECT_CONTENT;

export const useDefaultProjectContent = (): ProjectConfigurationDc => {
  const { options } = useMapModule();
  const { options: baseMapSelectOptions } = useBasemapSelectModule();
  const baseMapItems = baseMapSelectOptions ? (baseMapSelectOptions.items as BaseMapItem[]) : [];
  const baseMapName = baseMapItems[0]?.name || DEFAULT_BASE_MAP;

  return {
    ...DEFAULT_PROJECT_CONTENT,
    position: (options?.defaultPosition as Coordinates) || position,
    resolution: (options?.defaultResolution as number) || resolution,
    baseMapName,
  };
};
